(ns frontend.view.settings2.surveys.question.events
  (:require
   [ajax.core :as ajax]
   [clojure.set :as set]
   [common.util :as cu]
   [frontend.logging :as logging]
   [frontend.view.settings2.surveys.events :as survey-events]
   [frontend.view.settings2.surveys.question.sub :as sub]
   [re-frame.core :as rf]
   [ui.util :as uu]))

(rf/reg-event-fx
 ::add-language
 (fn [{db :db} [_ lang]]
   {:db (update-in db [::sub/selected-languages]
                   (fn [langs]
                     (into [:ENG]
                           (->> (set/difference (conj (set langs) lang)
                                                #{:ENG})
                                (sort)
                                (vec)))))}))

(rf/reg-event-fx
 ::set-languages
 (fn [{db :db} [_ languages]]
   {:db (assoc-in db [::sub/selected-languages]
                  (into [:ENG]
                        (->> languages
                             (remove (fn [l]
                                       (= :ENG l))))))}))

(rf/reg-event-fx
 ::set-language
 (fn [{db :db} [_ lang]]
   {:db (assoc-in db [::sub/selected-language] lang)}))

(rf/reg-event-fx
 ::set-data-type
 (fn [{db :db} [_ value]]
   {:db (assoc-in db [::sub/survey-question-changes :survey-question/data-type] value)}))

(rf/reg-event-fx
 ::set-file-abbreviation
 (fn [{db :db} [_ value]]
   {:db (assoc-in db [::sub/survey-question-changes :survey-question/file-name-abbreviation] value)}))

(rf/reg-event-fx
 ::set-multi-file?
 (fn [{db :db} [_ value]]
   {:db (assoc-in db [::sub/survey-question-changes :survey-question/multi-file?] value)}))

(rf/reg-event-fx
 ::set-unique-identifier?
 (fn [{db :db} [_ value]]
   {:db (assoc-in db [::sub/survey-question-changes :survey-question/unique-identifier?] value)}))

(rf/reg-event-fx
 ::set-file-types
 (fn [{db :db} [_ values]]
   {:db (assoc-in db [::sub/survey-question-changes :survey-question/accepted-file-types] values)}))

(rf/reg-event-fx
 ::set-option-list
 (fn [{db :db} [_ value]]
   {:db (assoc-in db [::sub/survey-question-changes :survey-question/option-list] value)}))

(rf/reg-event-fx
 ::set-label
 (fn [{db :db} [_ lang value]]
   {:db (assoc-in db [::sub/survey-question-changes :survey-question/label-translations lang] value)}))

(rf/reg-event-fx
 ::set-data-unit
 (fn [{db :db} [_ value]]
   {:db (assoc-in db [::sub/survey-question-changes :survey-question/data-unit] value)}))

(rf/reg-event-fx
 ::set-info
 (fn [{db :db} [_ lang value]]
   (js/console.log "Set info : " lang " > " value)
   {:db (assoc-in db [::sub/survey-question-changes :survey-question/info-translations lang] value)}))

(rf/reg-event-fx
 ::add-option
 (fn [{db :db} _]
   (let [old-options (get-in db [::sub/survey-question-changes :survey-question/options])
         new-options (conj (if (vector? old-options)
                             old-options
                             [])
                           (uu/with-react-key {}))]
     {:db (assoc-in db [::sub/survey-question-changes :survey-question/options] new-options)})))

(rf/reg-event-fx
 ::add-external-ids
 (fn [{db :db} _]
   (let [old-ids (get-in db [::sub/survey-question-changes :survey-question/external-ids])
         new-ids (conj (if (vector? old-ids)
                         old-ids
                         [])
                       (uu/with-react-key {}))]
     {:db (assoc-in db [::sub/survey-question-changes :survey-question/external-ids] new-ids)})))

(rf/reg-event-fx
 ::set-question-battery-value
 (fn [{db :db} [_ idx value]]
   {:db (assoc-in db [::sub/survey-question-changes :survey-question/external-ids idx :survey-question-ext-id/question-battery :db/id] value)}))

(rf/reg-event-fx
 ::set-external-id-value
 (fn [{db :db} [_ idx value]]
   {:db (assoc-in db [::sub/survey-question-changes :survey-question/external-ids idx :survey-question-ext-id/external-id] value)}))

(rf/reg-event-fx
 ::remove-ext-id
 (fn [{db :db} [_ index]]
   {:db (update-in db
                   [::sub/survey-question-changes :survey-question/external-ids]
                   (fn [orig-vec]
                     (cu/vec-remove index orig-vec)))}))

(rf/reg-event-fx
 ::remove-option
 (fn [{db :db} [_ index]]
   {:db (update-in db
                   [::sub/survey-question-changes :survey-question/options]
                   (fn [orig-vec]
                     (cu/vec-remove index orig-vec)))}))

(rf/reg-event-fx
 ::move-first-option
 (fn [{db :db} [_ index]]
   {:db (update-in db
                   [::sub/survey-question-changes :survey-question/options]
                   (fn [orig-vec]
                     (cu/vec-move orig-vec index 0)))}))
(rf/reg-event-fx
 ::move-up-option
 (fn [{db :db} [_ index]]
   {:db (update-in db
                   [::sub/survey-question-changes :survey-question/options]
                   (fn [orig-vec]
                     (cu/vec-move orig-vec index (dec index))))}))
(rf/reg-event-fx
 ::move-down-option
 (fn [{db :db} [_ index]]
   {:db (update-in db
                   [::sub/survey-question-changes :survey-question/options]
                   (fn [orig-vec]
                     (cu/vec-move orig-vec index (inc index))))}))

(rf/reg-event-fx
 ::set-question-option-localization
 (fn [{db :db} [_ lang index value]]
   {:db (assoc-in db
                  [::sub/survey-question-changes :survey-question/options index :survey-question-option/label-translations lang]
                  value)}))

(rf/reg-event-fx
 ::input-keyword
 (fn [{db :db} [_ value]]
   {:db (assoc-in db [::sub/survey-question-changes :survey-question/temp-keyword] value)}))

(rf/reg-event-fx
 ::set-keyword
 (fn [{db :db} _]
   (let [temp-kw (get-in db [::sub/survey-question-changes :survey-question/temp-keyword])
         old-kws (get-in db [::sub/survey-question-changes :survey-question/keywords])
         new-kws (cond (cu/blank-value? temp-kw)
                       old-kws
                       (empty? old-kws)
                       [temp-kw]
                       :else
                       (vec (distinct (concat old-kws [temp-kw]))))
         cleaned (->> new-kws
                      (remove cu/blank-value?)
                      (vec))]
     {:db (-> db
              (assoc-in [::sub/survey-question-changes :survey-question/keywords] cleaned)
              (assoc-in [::sub/survey-question-changes :survey-question/temp-keyword] ""))})))

(rf/reg-event-fx
 ::remove-keyword
 (fn [{db :db} [_ k]]
   (let [old-kws (get-in db [::sub/survey-question-changes :survey-question/keywords])
         new-kws (vec (remove cu/blank-value? (set/difference (set old-kws) #{k})))]
     {:db (assoc-in db [::sub/survey-question-changes :survey-question/keywords] new-kws)})))

(rf/reg-event-fx
 ::on-save-question-ok
 (fn [{db :db} [_ resp]]
   {:db (dissoc db ::sub/survey-question-changes)
    :fx [[:dispatch [::survey-events/close-question-creator (:body resp)]]]}))

(rf/reg-event-fx
 ::on-save-question-failed
 (fn [{_db :db} [_ err]]
   (logging/unimplemented "Failed to save question : " err)))

(rf/reg-event-fx
 ::on-delete-question-ok
 (fn [{_db :db} [_ resp]]
   {:fx [[:dispatch [::survey-events/close-question-creator (:body resp)]]]}))

(rf/reg-event-fx
 ::on-delete-question-failed
 (fn [{_db :db} [_ err]]
   (logging/unimplemented "Failed to delete question : " err)))

(rf/reg-event-fx
 ::delete-question
 (fn [{db :db} _]
   {:db         (-> db
                    (assoc-in [::sub/processing] true))
    :http-xhrio {:method          :post
                 :uri             "/surveys/api/delete-question"
                 :params          (select-keys (get-in db [::sub/survey-question-changes])
                                               [:db/id])
                 :timeout         30000
                 :format          (ajax/transit-request-format)
                 :response-format (ajax/transit-response-format)
                 :on-success      [::on-delete-question-ok]
                 :on-failure      [::on-delete-question-failed]}}))
(rf/reg-event-fx
 ::save
 (fn [{db :db} _]
   (let [question (get-in db [::sub/survey-question-changes])]
     {:db         (-> db
                      (assoc-in [::sub/processing] true))
      :http-xhrio {:method          :post
                   :uri             "/surveys/api/save-question"
                   :params          (merge
                                     (select-keys question
                                                  [:db/id
                                                   :survey-question/label-translations
                                                   :survey-question/info-translations
                                                   :survey-question/data-type
                                                   :survey-question/data-unit
                                                   :survey-question/keywords
                                                   :survey-question/multi-file?
                                                   :survey-question/accepted-file-types
                                                   :survey-question/file-name-abbreviation
                                                   :survey-question/calculation-rules
                                                   :survey-question/unique-identifier?])
                                     (when-let [options (:survey-question/options question)]
                                       {:survey-question/options (->> options
                                                                      (map-indexed (fn [idx opt]
                                                                                     {:survey-question-option/label-translations
                                                                                      (:survey-question-option/label-translations opt)
                                                                                      :common/ord (double idx)
                                                                                      :db/id      (get opt :db/id (str "option-" idx))}))
                                                                      (doall))})
                                     (when-let [external-ids (:survey-question/external-ids question)]
                                       {:survey-question/external-ids (->> external-ids
                                                                      (map-indexed (fn [idx opt]
                                                                                     {:survey-question-ext-id/question-battery
                                                                                      (:db/id (:survey-question-ext-id/question-battery opt))
                                                                                      :survey-question-ext-id/external-id
                                                                                      (:survey-question-ext-id/external-id opt)
                                                                                      :db/id      (get opt :db/id (str "ext-id-" idx))}))
                                                                      (doall) 
                                                                           (vec))}))
                   :timeout         30000
                   :format          (ajax/transit-request-format)
                   :response-format (ajax/transit-response-format)
                   :on-success      [::on-save-question-ok]
                   :on-failure      [::on-save-question-failed]}})))
